export default __webpack_public_path__ + "static/media/FacebookClone3.542f6f18.jpg";